export const isLaunchInProgressError = (error) => error?.response?.status === 409
  && error?.response?.data?.code === 'launch_in_progress';
